export default {
  Sent: 1, // Đã gửi
  UnSend: 0, // Chưa gửi
}
